import {executeHtmlHooks} from '@theme-modern-js/utils/htmlHooks';

$(document).ready(function () {
    $('.go-to-compare').on('click', function (e) {
        let modal = $('#addToCompareModal');
        modal.modal('hide');
        window.location.href = window.config.urls.compare.index;
    })

    /*
     * Add product to compare list
     */
    $('body').on('click', '.add-to-compare', function (event) {
        event.preventDefault();
        let productId = $(event.target).closest('a').data('product-id');
        addToCompare(productId);
    });

    /**
     * Entering a product to the compare list, when finding the product in the
     *    Product quick search on the compare page.
     */
    $('#add-to-compare-quick').on('click', function (event) {
        event.preventDefault();
        let productId = $('#searchProductsId').val();
        addToCompareOnPage(productId);
    });

    /**
     * Responsible for removing products from the compare page.
     */
    $('body').on('click', '.remove-from-compare', function (event) {
        event.preventDefault();
        let productId = $(event.target).data('productId');
        let url = window.config.urls.compare.remove.replace('#####', productId);
        window.axios.delete(url)
            .then(({data: data}) => {
                const compareTable = $('#product-compare-table');
                compareTable.html(data.content);
                executeHtmlHooks(compareTable[0]);

                location.reload();
            });


    });

    /**
     * Responsible for removing products from the compare modal.
     */
    $('body').on('click', '.remove-from-compare-modal', function (event) {
        event.preventDefault();
        let productId = $(event.target).data('productId');
        let url = window.config.urls.compare.removeFromModal.replace('#####', productId);
        window.axios.delete(url)
            .then(({data: data}) => {
                $('#compareMessageContainer').text(data.message);
                const compareModalContent = $('#compareModalContent');
                compareModalContent.html(data.content);
                executeHtmlHooks(compareModalContent[0]);
            });
    });
});

$(document).ready(function () {
    updateCompareIconQuantity();
    $('body').on('click', '.flush-compare', function () {
        window.axios.post(window.config.urls.compare.flush)
            .then(({data: data}) => {
                $('#compare-flush-modal').modal('hide');
                if (data.success) {
                    window.location.reload();
                }
            });
    });
});

function addToCompare(productId) {
    if (productId) {
        window.axios.post(window.config.urls.compare.add, {
            productId: productId,
        }).then(({data: data}) => {
            let modal = $('#addToCompareModal');
            $('#compareMessageContainer').text(data.message);
            const compareModalContent = $('#compareModalContent');
            compareModalContent.html(data.content);
            modal.modal('show');
            updateCompareIconQuantity();
            executeHtmlHooks(compareModalContent[0]);
        });
    }
}

/**
 * Add a product to compare when being on the compare page
 *  => the content is directly replaced in the page (no popup as usual)
 *
 * @param productId
 */
function addToCompareOnPage(productId) {
    if (productId) {
        window.axios.post(window.config.urls.compare.add + '/table', {
            productId: productId,
        }).then(({data: data}) => {
            $('#product-compare-table').html(data.content);
        });
    }
}

function updateCompareIconQuantity() {
    let countCompareElements = 0;
    window.axios.get(window.config.urls.compare.count).then(({data}) => {
        if(data.count > 0) {
            $('.compare-counter').removeClass('visually-hidden');
            $('.compare-counter').text(data.count);
        } else {
            $('.compare-counter').addClass('visually-hidden');
        }

    });
}

/**
 * Update the products-table
 */
function updateCompareTable() {
    let productTable = $('#product-compare-table');
    if (!productTable) {
        return false;
    }
    let url = window.config.urls.compare.table;
    window.axios.get(url).then(({data}) => {
        productTable.html(data.view);
        executeHtmlHooks(productTable[0]);
        /* clear quick search */
        $('.quick-search').val('');
        $('#quick-search-image').html('');
        $('#quick-search-name').html('');
        $('#quick-search-price').html('');
        $('#quick-search-id').attr('data-product-id', '');
        if (data.hasProducts) {
            $('.require-products').show();
        } else {
            $('.require-products').hide();
        }
    });
}

/**
 * Quick search on compare page
 */
$(document).ready(function () {
    $('.quick-search').keyup(function () {
        let productNumber = $(this).val();
        let url = window.config.urls.fastProductEntryRow;
        url = url.replace('#####', productNumber);
        window.axios.get(url)
            .then(({data}) => {
                if (data.success) {
                    $('#quick-search-image').html(data.image);
                    $('#quick-search-name').html(data.name);
                    $('#quick-search-price').html(data.price);
                    $('#quick-search-id').attr('data-product-id', data.id);
                }
            });
    });
});

/**
 * Radio toggle -- Highlight rows
 */
$(document).ready(function () {
    $('input[type=radio][name=showCompare]').change(function(e) {
        switch (e.target.value) {
            case 'list1':
                clearHighlighting();
                break;
            case 'list2':
                checkSameAttrs();
                break;
            case 'list3':
                checkDifferentAttrs();
                break;
            default:
                clearHighlighting();
        }

    });

});

function clearHighlighting() {
    $('.main-table__row--attrs').children().css('background', '');
}

function checkSameAttrs() {
    let attrRow = $('.main-table__row--attrs');
    attrRow.each(function() {
        let rowArray = []
        let item = $(this).find('.is-product-compare__col');
        item.each(function(index) {
            let itemVal = $(this).data('value');
            rowArray.push(itemVal);
            if(rowArray[0] === rowArray[index]) {
                $(this).closest('.main-table__row').children().css('background', '#fff3cd');
            } else {
                $(this).closest('.main-table__row').children().css('background', '');
            }
        });
    });
}

function checkDifferentAttrs() {
    let attrRow = $('.main-table__row--attrs');
    attrRow.each(function() {
        let rowArray = []
        let item = $(this).find('.is-product-compare__col');
        item.each(function(index) {
            let itemVal = $(this).data('value');
            rowArray.push(itemVal);
            if(rowArray[0] !== rowArray[index]) {
                $(this).closest('.main-table__row').children().css('background', '#fff3cd');
            } else {
                $(this).closest('.main-table__row').children().css('background', '');
            }
        });
    });
}
